__turbopack_context__.v({
  "className": "ibm_plex_mono_c7d8cc32-module__U1BAtG__className",
  "variable": "ibm_plex_mono_c7d8cc32-module__U1BAtG__variable",
});
